'use strict';

const css = require('./Header-style.scss');
const React = require('react');
const PropTypes = require('prop-types');
const CloseIcon = require('dibs-vg/dist/react/close');

const Header = ({children, closeModal, dataTn, headerClass, closeIconClass}) => (
    <div className={headerClass || css.header}>
        <div className={css.title}>{children}</div>
        <div className={css.close} onClick={closeModal} data-tn={`${dataTn}-modal-close`}>
            <CloseIcon className={closeIconClass || css.closeButton} />
        </div>
    </div>
);

Header.propTypes = {
    children: PropTypes.node,
    closeModal: PropTypes.func,
    dataTn: PropTypes.string,
    headerClass: PropTypes.string,
    closeIconClass: PropTypes.string
};

module.exports = Header;



// WEBPACK FOOTER //
// ./assets/js/global/views/modal/Header.jsx